export const parseRecoveredUsername = (data: unknown): string => {
  if (typeof data === "string" && data.trim()) return data.trim();
  if (data && typeof data === "object") {
    const record = data as Record<string, unknown>;
    const candidate =
      record.username ?? record.userName ?? record.user_name ?? "";
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }
  return "";
};
